import { render, staticRenderFns } from "./storeReport2.vue?vue&type=template&id=2db0618f&scoped=true&"
import script from "./storeReport2.vue?vue&type=script&lang=js&"
export * from "./storeReport2.vue?vue&type=script&lang=js&"
import style0 from "./storeReport2.vue?vue&type=style&index=0&id=2db0618f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0618f",
  null
  
)

component.options.__file = "storeReport2.vue"
export default component.exports